/* IK — real PIN code check on product pages.
   Looks the PIN up in India Post's public directory, so made-up PINs (000000, 999999)
   are rejected and real ones show the area name and an expected delivery window.
   If the lookup is slow or down, it falls back to the delivery estimate so the
   shopper is never blocked. Runs before the old handler in ikl-cart.js and stops it. */
(function () {
  if (window.__iklPin) return;
  window.__iklPin = true;

  var KEY = 'ikl_pin';
  var DAY = 864e5;
  var fmt = function (d) {
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  };
  function addWorkingDays(d, n) {
    d = new Date(d);
    while (n > 0) { d = new Date(d.getTime() + DAY); if (d.getDay() !== 0) n--; }
    return d;
  }
  function windowText(form) {
    var cutoff = parseInt(form.closest('.ikl-delivery') && form.closest('.ikl-delivery').querySelector('[data-ikl-countdown]') ?
      form.closest('.ikl-delivery').querySelector('[data-ikl-countdown]').getAttribute('data-ikl-countdown') : '20', 10);
    var now = new Date();
    var ship = now.getHours() < cutoff ? addWorkingDays(now, 1) : addWorkingDays(now, 2);
    return fmt(addWorkingDays(ship, 2)) + ' – ' + fmt(addWorkingDays(ship, 6));
  }
  function title(s) { return String(s || '').toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }

  function show(out, kind, html) {
    out.className = 'ikl-delivery__result ikl-pin--' + kind;
    out.innerHTML = html;
  }

  function check(form, quiet) {
    var input = form.querySelector('input');
    var btn = form.querySelector('button');
    var out = form.parentElement.querySelector('[data-ikl-delivery-result]');
    if (!input || !out) return;
    var pin = (input.value || '').replace(/\D/g, '');
    input.value = pin;
    if (!/^[1-9][0-9]{5}$/.test(pin)) {
      if (!quiet) show(out, 'bad', 'Please enter a valid 6-digit PIN code.');
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Checking…';
    show(out, 'wait', 'Checking ' + pin + '…');

    var done = false;
    var eta = windowText(form);
    function ok(place) {
      try { localStorage.setItem(KEY, pin); } catch (e) {}
      show(out, 'ok',
        '<strong>&#10003; Delivers to ' + (place ? place + ' (' + pin + ')' : pin) + '</strong>' +
        '<span>Get it by <b>' + eta + '</b> &middot; Cash on Delivery available</span>');
    }
    function finish() { done = true; btn.disabled = false; btn.textContent = 'Check'; }

    var timer = setTimeout(function () { if (!done) { finish(); ok(''); } }, 4000);
    fetch('https://api.postalpincode.in/pincode/' + pin)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (done) return;
        clearTimeout(timer);
        finish();
        var row = data && data[0];
        if (row && row.Status === 'Success' && row.PostOffice && row.PostOffice.length) {
          var po = row.PostOffice[0];
          ok(title(String(po.District || po.Name).replace(/\s*\(.*?\)\s*/g, ' ').trim()) + ', ' + title(po.State));
        } else if (row && row.Status === 'Error') {
          try { localStorage.removeItem(KEY); } catch (e) {}
          show(out, 'bad', 'We couldn&rsquo;t find PIN code ' + pin + '. Please check it and try again.');
        } else {
          ok('');
        }
      })
      .catch(function () { if (!done) { clearTimeout(timer); finish(); ok(''); } });
  }

  /* Capture phase on document runs before the form's own listener, so the old
     "always says yes" handler never fires. */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-ikl-delivery-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    check(form);
  }, true);

  function prep() {
    document.querySelectorAll('[data-ikl-delivery-form]').forEach(function (form) {
      if (form.dataset.iklPinReady) return;
      form.dataset.iklPinReady = '1';
      var input = form.querySelector('input');
      if (!input) return;
      input.setAttribute('maxlength', '6');
      input.setAttribute('pattern', '[0-9]*');
      input.setAttribute('autocomplete', 'postal-code');
      input.setAttribute('enterkeyhint', 'go');
      input.addEventListener('input', function () {
        var v = input.value.replace(/\D/g, '').slice(0, 6);
        if (v !== input.value) input.value = v;
        if (v.length === 6) check(form);
      });
      var saved = '';
      try { saved = localStorage.getItem(KEY) || ''; } catch (e) {}
      if (saved) { input.value = saved; check(form, true); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prep); else prep();
})();
